<template>
  <div v-if="heroBanner.length" class="hero-section my-4">
    <div v-if="!isLoaded" class="hero-skeleton"></div>

    <div v-show="isLoaded" class="hero-wrapper">
      <img
        :src="`${BASE_IMAGE_PREFIX}/${currentImageUrl}`"
        alt="Hero Banner"
        class="hero-img"
        @load="handleImageLoad"
        @click="$router.push(`/search?c=${heroBanner[currentIndex].linkTo}`)"
      />

      <!-- Left Arrow -->
      <button class="arrow-btn left" @click="prevImage">
        <i class="bi bi-chevron-left"></i>
      </button>

      <!-- Right Arrow -->
      <button class="arrow-btn right" @click="nextImage">
        <i class="bi bi-chevron-right"></i>
      </button>
    </div>
  </div>
  <div v-else>
    <div class="hero-skeleton"></div>
  </div>
</template>

<script>
import { BASE_IMAGE_PREFIX } from '@/globals';
export default {
  name: "HeroSection",
  props: {
    heroBanner: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      BASE_IMAGE_PREFIX,
      currentIndex: 0,
      intervalId: null,
      loadedImages: new Set(),
      isLoaded: false,
    };
  },
  computed: {
    currentImageUrl() {
      return this.heroBanner[this.currentIndex]?.imageUrl || "";
    },
  },
  watch: {
    currentIndex() {
      this.checkIfLoaded();
    },
  },
  mounted() {
    this.checkIfLoaded(); // for first image
    this.startSlider();
  },
  beforeUnmount() {
    clearInterval(this.intervalId);
  },
  methods: {
    startSlider() {
      this.intervalId = setInterval(() => {
        this.nextImage();
      }, 4000);
    },
    nextImage() {
      this.currentIndex = (this.currentIndex + 1) % this.heroBanner.length;
    },
    prevImage() {
      this.currentIndex =
        (this.currentIndex - 1 + this.heroBanner.length) % this.heroBanner.length;
    },
    checkIfLoaded() {
      this.isLoaded = this.loadedImages.has(this.currentImageUrl);
    },
    handleImageLoad() {
      this.loadedImages.add(this.currentImageUrl);
      this.isLoaded = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.hero-section {
  width: 100%;
  border-radius: 20px;
  overflow: hidden;
  cursor: pointer;
  position: relative;
}

.hero-wrapper {
  position: relative;
}

.hero-img {
  width: 100%;
  height: auto;
  object-fit: cover;
  display: block;
  border-radius: 20px;
  transition: opacity 0.5s ease-in-out;
}

/* Arrows */
.arrow-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.6);
  border: none;
  border-radius: 50%;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.3s ease, opacity 0.3s ease;
  opacity: 0;
  z-index: 10;

  i {
    font-size: 1.5rem;
    color: #333;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.9);
  }

  &.left {
    left: 15px;
  }

  &.right {
    right: 15px;
  }
}

.arrow-btn {
  opacity: 0.4;
}

.hero-wrapper:hover .arrow-btn {
  opacity: 1;
}

/* Skeleton */
.hero-skeleton {
  margin-top: 20px;
  margin-bottom: 20px;
  width: 100%;
  height: 500px;
  border-radius: 12px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.2s infinite linear;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .hero-skeleton {
    height: 250px;
  }
  .arrow-btn {
    width: 36px;
    height: 36px;
    opacity: 1;
    i {
      font-size: 1.2rem;
    }
  }
}
</style>
